import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessagePlusOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 3H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h3v6a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l6.7-6.71H27a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m1 3v13a1 1 0 0 1-1 1H16a1 1 0 0 0-.71.3L10 25.59V22a2 2 0 0 0-2-2H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1"
    />
    <path
      fill="currentColor"
      d="M20 11.5h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMessagePlusOutlineSVG);
ForwardRef.displayName = "IconMessagePlusOutline";
export { ForwardRef as IconMessagePlusOutline };
